module.exports = __webpack_public_path__ + "static/media/valvula-seg-02.c676642e.jpg";